// extracted by mini-css-extract-plugin
export var Bank = "index-module--Bank--0CnMF";
export var linkBtn = "index-module--linkBtn--WdMUm";
export var textBtn = "index-module--textBtn--I27+O";